import {setUserToken} from 'features/common/utils/token'
import {HTTPError} from 'ky'
import {z} from 'zod'
import api from '../../../transport'

const signupResponseSchema = z.object({
    token: z.string(),
})

type SignupProps = {
    name: string
    organization: string
    country: string
    phone: string
    email: string
    password: string
}

const ERROR_STATUS_EMAIL_IS_ALREADY_USED = 409

const signup = async (data: SignupProps) => {
    try {
        const res = await api
            .post('auth/signUp', {
                body: JSON.stringify(formSignupResponse(data)),
            })
            .json()

        const parseRes = signupResponseSchema.parse(res)
        setUserToken(parseRes.token)
        return parseRes.token
    } catch (err) {
        if (err instanceof HTTPError) {
            if (err.response.status === ERROR_STATUS_EMAIL_IS_ALREADY_USED) {
                throw new Error('ERROR_EMAIL_IS_ALREADY_USED')
            }
        }
    }
}

const formSignupResponse = (data: SignupProps) => ({
    name: data.name,
    organization_name: data.organization,
    country_code: data.country,
    phone: data.phone,
    email: data.email,
    password: data.password,
})

export default signup
